export default {
  error: 'Error',
  warning: 'Warning',
  'error.errorNum': 'Error: {number}',
  'error.notFound': '{entity} not found',
  'error.page403': 'Sorry, you are not authorized to access this page',
  'error.page404': 'Sorry, the page you visited does not exist',
  'error.page500': 'Sorry, something went wrong',
  'error.pageWarning': 'There are some problems with your operation',
  'error.noPermissions': 'Has no relevant permissions',
  'error.userExist': 'The user already exist',
  'error.userAssigned': 'The user already assigned to business',
  'error.noEmail': 'Email address is required',
  'error.validEmail': 'Please enter a valid email address',
  'error.noConnection': 'No internet connection',
  'error.na': 'None',
  'error.fileSize': 'File size exceeds the limit of {size}MB',
  'error.uploadRestriction': 'Is allowed to upload only {extensions} files',
  'error.reCAPTCHA.loaded': 'reCAPTCHA not loaded',
  'error.load.script': 'Failed to load script',
};
